import React, { useEffect, useState } from "react";
import { Grid, Button } from "@mui/material";
import { Field } from "formik";
import BindingItems from "../BindingItems";
import { getBindings } from "app/services/api/bindings";

const BindingsTab = ({
  t,
  values,
  setFieldValue,
  handleSortEnd,
  handleChipSortEnd,
  handleAddGroup,
  handleAddBinding,
  handleDelete,
  allProducts,
  defaultLanguage,
  currencyCode,
}) => {
  const [bindingsList, setBindingsList] = useState([]);

  useEffect(() => {
    let mounted = true;
    getBindings()
      .then((list) => {
        if (mounted) setBindingsList(Array.isArray(list) ? list : []);
      })
      .catch(() => {
        if (mounted) setBindingsList([]);
      });
    return () => { mounted = false; };
  }, []);

  return (
    <Grid
      container
      columnSpacing={2}
      rowSpacing={2}
      sx={{ minHeight: "fit-content" }}
    >
      <Grid item md={12} xs={12} display="flex" justifyContent="center">
        <Button
          size="normal"
          variant="contained"
          onClick={() => {
            setFieldValue("bindings.name", {});
            setFieldValue("bindings.min", 0);
            setFieldValue("bindings.max", 0);
            handleAddGroup();
          }}
        >
          {t("pages.dsokProducts.addBinding")}
        </Button>
      </Grid>
      <Field
        component={BindingItems}
        bindings={values.bindings}
        bindingsList={bindingsList}
        onSortEnd={({ oldIndex, newIndex }) =>
          handleSortEnd(oldIndex, newIndex, values.bindings, setFieldValue)
        }
        onChipSortEnd={(bindingCode, oldIndex, newIndex) =>
          handleChipSortEnd(
            bindingCode,
            oldIndex,
            newIndex,
            values.bindings,
            setFieldValue
          )
        }
        onAddGroup={handleAddGroup}
        onAddBinding={handleAddBinding}
        onDelete={handleDelete}
        allProducts={allProducts}
        defaultLanguage={defaultLanguage}
        currencyCode={currencyCode}
      />
    </Grid>
  );
};

export default BindingsTab;
